<template>
  <div v-if="!isShowingLoading" :class="$style['container']">
    <SideBar />

    <div :class="[$style['content'], { [$style['menuExpaned']]: isMenuExpanded }]">
      <HistoryTable />
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';

import SideBar from '@components/SideBar.vue';
import HistoryTable from '@/components/history/HistoryTable.vue';

const store = useStore();

const isMenuExpanded   = computed(() => store.getters['helpers/isMenuExpanded']);
const isShowingLoading = computed(() => store.getters['helpers/isShowingLoading']);

onMounted(() => {
  store.dispatch('helpers/hideLoading');
});
</script>

<style lang="scss" module>
.container {
  width: 100%;
  display: flex;

  .content {
    flex: 1;
    padding: 20px 20px 20px 0;
    overflow-x: hidden;
    overflow-y: scroll;

    &.menuExpaned {
      position: absolute;
      margin-left: 50px;
      height: 100%;
      width: -webkit-fill-available;

      .wrapper-report {
        position: absolute;
        width: 90%;
      }
    }
  }
}
</style>
